import React from 'react';
import { Address } from 'cpie-common';
import { AddressList } from './AddressList';
import { useTranslation } from 'react-i18next';
import { DataOverview } from '@vwfs-bronson/bronson-react';
import { EditStatus } from '../EditStatus';
import { Notification, NotificationStatus } from '@cp-shared-15/frontend-ui';
import { ErrorNotification } from '../../../notifications/error/ErrorNotification';

export type ConsultViewProps = {
    startEditing: () => void;
    address: Address;
    lastEditStatus: EditStatus;
};

export const ConsultView: React.FC<ConsultViewProps> = ({ startEditing, address, lastEditStatus }) => {
    const { t } = useTranslation('my-profile-address-details');

    if (!address) {
        return null;
    }

    const notification =
        lastEditStatus === EditStatus.SUCCESS ? (
            <Notification
                status={NotificationStatus.warning}
                headline={t('edit-view.notification-success.headline')}
                testId={'success-notification'}
            >
                <strong>{t('edit-view.notification-success.text')}</strong>
            </Notification>
        ) : (
            <ErrorNotification
                text={
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t('edit-view.notification-error.text'),
                        }}
                    />
                }
                testId={'error-notification'}
            />
        );

    return (
        <DataOverview
            titleLevel={3}
            title={t('consult-view.title')}
            buttonLabel={t('translation:editable-section-nav.start')}
            href="#"
            buttonProps={{
                onClick: startEditing,
                testId: 'edit-button',
                secondary: true,
                icon: '',
                link: false,
                type: 'button',
                // element: 'button',
            }}
        >
            <AddressList address={address} />
            {lastEditStatus !== EditStatus.NOT_PERFORMED && notification}
        </DataOverview>
    );
};
